<ion-list mode="ios" lines="none" class="list-forms">
  <!-- * Copy -->
  <ion-item
    mode="md"
    color="gray"
    lines="none"
    class="ion-text-center item-copy"
  >
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="please-enter-code-sent-sms"
    >
      {{ "Labels.please-enter-code-sent-sms" | translate }}
    </ion-label>
  </ion-item>

  <!-- * Numero ingresado -->
  <ion-item mode="md" color="gray" lines="none" class="ion-text-center">
    <ion-label mode="md" color="darkblue" color="tpcta" class="phone-number">
      {{ numero }}
    </ion-label>
  </ion-item>

  <!-- ? Formulario -->
  <form [formGroup]="codeForm" (ngSubmit)="onSubmitTemplate()">
    <!-- * Código -->
    <ion-item
      mode="md"
      lines="none"
      color="gray"
      class="mpe-input-square-floating"
    >
      <ion-label position="floating" mode="md" color="status-icon-enable">
        <ion-text mode="md" color="danger">
          {{ "Forms.asterisk" | translate }}
        </ion-text>
        {{ "Forms.sms-code" | translate }}
      </ion-label>

      <ion-input
        type="tel"
        formControlName="codigo"
        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')"
        mode="ios"
        color="medium"
        debounce="300"
        minlength="6"
        maxlength="6"
        enterkeyhint="done"
        class="input-code"
        [ngClass]="
          (codeForm.get('codigo').value | isNullEmpty)
            ? 'border-base'
            : codeForm.get('codigo').invalid
            ? 'border-danger'
            : 'border-valid'
        "
      >
      </ion-input>
      <!-- Manejo de Mensajes Reactivos -->
      <ng-container
        *ngIf="
          !(codeForm.get('codigo').value | isNullEmpty) &&
          codeForm.get('codigo').invalid
        "
      >
        <p>{{ "Forms.invalid-code" | translate }}</p>
      </ng-container>
    </ion-item>

    <!-- * Aceptar -->
    <ion-item mode="md" color="gray" lines="none" class="ion-text-center">
      <ion-button
        class="aceptar"
        color="darkblue"
        [disabled]="codeForm.invalid || spinner"
        type="submit"
      >
        <ion-spinner
          name="crescent"
          slot="start"
          *ngIf="spinner"
          class="spinner-accept"
        ></ion-spinner>
        {{ "Buttons.confirm" | translate }}
      </ion-button>
    </ion-item>
  </form>
</ion-list>

<ion-list
  mode="ios"
  lines="none"
  class="list-buttons"
  [ngStyle]="{ height: ListButtonsCode }"
>
  <hr class="separator-gray-dashed" />

  <!-- ? Botones -->
  <ion-item-group>
    <ion-item class="" lines="none" mode="md" color="gray">
      <ion-label mode="md" color="status-icon-enable" class="phone-entered">
        {{ "Labels.phone-entered" | translate }}

        <p class="phone-entered">
          {{ numero }}
        </p>
      </ion-label>

      <ion-label
        mode="md"
        color="status-icon-enable"
        class="phone-entered ion-text-end"
        slot="end"
        [innerHTML]="
          'Labels.' +
            (smsCountDown.countdown > 0
              ? 'didnt-receive-code-wait'
              : 'didnt-receive-code-wait-2')
            | translate : smsCountDown
            | htmlSeguro
        "
      >
      </ion-label>
    </ion-item>

    <ion-item lines="none" mode="md" color="gray" class="items-buttons">
      <ion-button
        mode="md"
        color="darkblue"
        fill="clear"
        class="mpe-button-link-line ion-no-padding button-link"
        (click)="prevNumber()"
        slot="start"
      >
        <ion-label mode="md" class="mpe-font-weight-600">
          {{ "Buttons.change-number" | translate }}
        </ion-label>
      </ion-button>

      <ion-button
        mode="md"
        color="darkblue"
        fill="clear"
        class="mpe-button-link-line ion-no-padding button-link"
        slot="end"
        (click)="sendCodeNew(telefono)"
        [disabled]="smsCountDown.countdown > 0 || spinnerSendSms"
      >
        <ion-spinner
          name="lines"
          *ngIf="spinnerSendSms"
          class="spinner-code"
        ></ion-spinner>
        <ion-label mode="md" class="mpe-font-weight-600">
          {{ "Buttons.request-new-code" | translate }}
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-item-group>

  <!-- * Copy -->
  <ion-item
    lines="none"
    mode="md"
    color="gray"
    class="ion-text-center items-buttons"
  >
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="cellular-network-connection"
    >
      {{ "Labels.cellular-network-connection" | translate }}
    </ion-label>
  </ion-item>
</ion-list>
